import api from '@/apis/cre/cRERepListAPI.js';
import Crud from '@/stores/crudBase';
import _ from 'lodash';

var crud = new Crud('cRERepList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'cre_rep_list',
    field: {
      key: 'cre_rep_list_id'
      // code: 'ref_no',
    }
  }
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
  /**
   * Lấy dữ liệu báo cáo B01BCTC
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async getDataBCTC(context, payload) {
    return await api.getDataReport(payload || {});
  },

  /**
   * Xóa dữ liệu ngoài danh sách
   * @param {*} context
   * @param {*} payload
   * NXCHIEN 28.09.2022
   */
  deleteReport(context, payload) {
    context.commit('deleteReport', payload);
  },

  /**
   * Thêm dữ liệu báo cáo ngoài danh sách
   * @param {*} context
   * @param {*} payload
   * NXCHIEN 28.09.2022
   */
  addReport(context, payload) {
    context.commit('addReport', payload);
  }
};
const mutations = {
  ...crud.mutations,

  /**
   * Cập nhật khi xóa bản ghi
   */
  deleteReport(state, payload) {
    let keyField = state._config.field.key;

    if (keyField) {
      if (payload.isDeleteMaster) {
        state.items = state.items?.filter(x => x[keyField] != payload[keyField]);
        state.total -= 1;
        if (state.total == 0) {
          state.empty = true;
        }
      } else {
        state.items = state.items?.filter(
          x => x[keyField] != payload[keyField] || x['report_id'] != payload['report_id']
        );
      }
    }

    state.version++;
  },

  /**
   * Cập nhật khi thêm bản ghi
   * NXCHIEN 28.09.2022
   */
  addReport(state, data) {
    // nếu là thêm mới 1 bộ bc
    if (data.isAddNew) {
      let reportIds = JSON.parse(data.report_id);
      let arr = [];
      reportIds.forEach(item => {
        let row = {
          cre_rep_list_id: data.cre_rep_list_id,
          period_name: data.period_name,
          budget_chapter_code: data.budget_chapter_code,
          report_date: data.report_date,
          company_report_preparer: data.company_report_preparer,
          company_chief_accountant: data.company_chief_accountant,
          created_by: data.created_by,
          created_date: data.created_date,
          modified_by: data.modified_by,
          modified_date: data.modified_date
        };

        switch (item) {
          case 'BCTC-01':
            row.report_name = 'B01/BCTC: Báo cáo tình hình tài chính';
            row.sort_order = 1;
            break;
          case 'BCTC-02':
            row.report_name = 'B02/BCTC: Báo cáo kết quả hoạt động';
            row.sort_order = 2;
            break;
          case 'BCTC-03a':
            row.report_name = 'B03a/BCTC: Báo cáo lưu chuyển tiền tệ (Theo phương pháp trực tiếp)';
            row.sort_order = 3;
            break;
          case 'BCTC-03b':
            row.report_name = 'B03b/BCTC: Báo cáo lưu chuyển tiền tệ (Theo phương pháp gián tiếp)';
            row.sort_order = 4;
            break;
          case 'BCTC-04':
            row.report_name = 'B04/BCTC: Thuyết minh báo cáo tài chính';
            row.sort_order = 5;
            break;
          case 'BCTC-01bstt':
            row.report_name = 'B01/BSTT: Báo cáo bổ sung thông tin tài chính';
            row.sort_order = 6;
            break;
          case 'BCTC-05':
            row.report_name = 'B05/BCTC: Báo cáo tài chính (Mẫu đơn giản)';
            row.sort_order = 7;
            break;
          case 'C03/CCTT':
            row.report_name = 'C03/CCTT: Báo cáo về việc cung cấp thông tin tài chính';
            row.sort_order = 8;
            break;
          default:
            break;
        }
        row.report_id = item;
        arr.push(row);
      });

      state.items = _.concat(arr, state.items);
      state.total += 1;
      state.empty = false;
      state.version++;
    } else {
      let arrReport = [];
      let oldIds = state.items?.filter(x => x.cre_rep_list_id == data.cre_rep_list_id)?.map(x => x.report_id) || [];
      let newIds = JSON.parse(data.report_id);
      let dataAddIds = newIds.filter(x => !oldIds?.find(o => o == x));

      state.items?.forEach(item => {
        if (item.cre_rep_list_id == data.cre_rep_list_id) {
          item.period_name = data.period_name;
          item.budget_chapter_code = data.budget_chapter_code;
          item.report_date = data.report_date;
          item.company_report_preparer = data.company_report_preparer;
          item.company_chief_accountant = data.company_chief_accountant;
          item.created_by = data.created_by;
          item.created_date = data.created_date;
          item.modified_by = data.modified_by;
          item.modified_date = data.modified_date;
        }
      });

      dataAddIds.forEach(item => {
        let row = {
          cre_rep_list_id: data.cre_rep_list_id,
          period_name: data.period_name,
          budget_chapter_code: data.budget_chapter_code,
          report_date: data.report_date,
          company_report_preparer: data.company_report_preparer,
          company_chief_accountant: data.company_chief_accountant,
          created_by: data.created_by,
          created_date: data.created_date,
          modified_by: data.modified_by,
          modified_date: data.modified_date
        };

        switch (item) {
          case 'BCTC-01':
            row.report_name = 'B01/BCTC: Báo cáo tình hình tài chính';
            row.sort_order = 1;
            break;
          case 'BCTC-02':
            row.report_name = 'B02/BCTC: Báo cáo kết quả hoạt động';
            row.sort_order = 2;
            break;
          case 'BCTC-03a':
            row.report_name = 'B03a/BCTC: Báo cáo lưu chuyển tiền tệ (Theo phương pháp trực tiếp)';
            row.sort_order = 3;
            break;
          case 'BCTC-03b':
            row.report_name = 'B03b/BCTC: Báo cáo lưu chuyển tiền tệ (Theo phương pháp gián tiếp)';
            row.sort_order = 4;
            break;
          case 'BCTC-04':
            row.report_name = 'B04/BCTC: Thuyết minh báo cáo tài chính';
            row.sort_order = 5;
            break;
          case 'BCTC-01bstt':
            row.report_name = 'B01/BSTT: Báo cáo bổ sung thông tin tài chính';
            row.sort_order = 6;
            break;
          case 'BCTC-05':
            row.report_name = 'B05/BCTC: Báo cáo tài chính (Mẫu đơn giản)';
            row.sort_order = 7;
            break;
          case 'C03/CCTT':
            row.report_name = 'C03/CCTT: Báo cáo về việc cung cấp thông tin tài chính';
            row.sort_order = 8;
            break;
          default:
            break;
        }
        row.report_id = item;
        arrReport.push(row);
      });
      state.items = _.concat(state.items, arrReport);
      state.version++;
    }
  },

  /**
   * override ko làm gì cả
   * NXCHIEN 28.09.2022
   */
  insertItem(state, data) {},
  /**
   * override ko làm gì cả
   * NXCHIEN 28.09.2022
   */
  updateItem(state, data) {}
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
